/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { NonceAttestationData } from './NonceAttestationData';
import {
    NonceAttestationDataFromJSON,
    NonceAttestationDataFromJSONTyped,
    NonceAttestationDataToJSON,
} from './NonceAttestationData';

/**
 * 
 * @export
 * @interface NonceAttestation
 */
export interface NonceAttestation {
    /**
     * 
     * @type {string}
     * @memberof NonceAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof NonceAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {NonceAttestationData}
     * @memberof NonceAttestation
     */
    data?: NonceAttestationData;
}

/**
 * Check if a given object implements the NonceAttestation interface.
 */
export function instanceOfNonceAttestation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;

    return isInstance;
}

export function NonceAttestationFromJSON(json: any): NonceAttestation {
    return NonceAttestationFromJSONTyped(json, false);
}

export function NonceAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonceAttestation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': !exists(json, 'data') ? undefined : NonceAttestationDataFromJSON(json['data']),
    };
}

export function NonceAttestationToJSON(value?: NonceAttestation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'challenge_id': value.challenge_id,
        'challenge_type': ChallengeTypeToJSON(value.challenge_type),
        'data': NonceAttestationDataToJSON(value.data),
    };
}

